<template>

  <v-container fluid fill-height pa-0>

    <v-layout column fill-height ma-0 pa-0>

      <v-layout fill-height ma-0 pa-0 >

        <v-flex xs12 >

          <v-layout fill-height column  ma-0 pa-0 >
           
            <scroll-area>

              <template slot="header">

                <v-toolbar class="active" :height="44" flat dark>
                  <v-toolbar-title>
                    <span class="body-2 uppercase blacktext--text">{{ $t('license') }}</span>
                  </v-toolbar-title>
                </v-toolbar>

              </template>

              <template slot="body">

                <v-layout column fill-height>
                  <scroll-area>

                    <template slot="body">
                      <v-flex v-if="getJsonLicense"  ma-0 pa-0 >
                        <json-viewer 
                          :value="getJsonLicense"
                          :expand-depth="5"
                        ></json-viewer>
                      </v-flex>
                    </template>

                    <template slot="footer">

                      <v-flex xs12 column  ma-0 pa-0 >
                        <v-layout   ma-0 py-3 >
                          <span class="title"> {{ $t('id') + ':'}}</span>
                          <v-layout shrink ma-0 pl-2 >
                            <span class="title text_select"> {{ deviceID }} </span>
                          </v-layout>
                        </v-layout>
                        <v-textarea
                            :data-testid="$options.name + '__textarea__' + 'licenseKey'"
                            v-model="licenseKey"
                            light
                            outline
                            flat
                            class="white"
                            background-color="primary"
                            hide-details
                            rows="5"
                          ></v-textarea>
                        
                      </v-flex>
                    </template>

                  </scroll-area>

                </v-layout>

              </template>

              <template slot="footer">
              <v-layout fill-height>
                <v-layout fill-height justify-start>
                  <v-btn dark small 
                  :data-testid="$options.name + '__btn__' + 'setLicense'"
                  @click="() => setLicense()" color="success">
                    {{$t('update license')}}
                  </v-btn>
                </v-layout>
                <v-layout fill-height justify-end>           
                </v-layout>
              </v-layout>
            </template>

            </scroll-area>

          </v-layout>
        </v-flex>
        
      </v-layout>

    </v-layout>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import JsonViewer from 'vue-json-viewer'

// Типы
interface LicenseData {
  data?: {
    config?: {
      config?: {
        'e-nms'?: any
      }
    }
  }
  [key: string]: any
}

interface DeviceInfo {
  data?: string
  [key: string]: any
}

interface LicenseResponse {
  data?: {
    accept?: boolean
  }
  [key: string]: any
}

export default Vue.extend({
  name: 'LICENSE',

  components: {
    scrollArea,
    JsonViewer,
  },

  props: {
    data: {
      type: Object as () => any,
      default: () => ({})
    },
  },

  data(): {
    model: Record<string, any>
    deviceID: string
    licenseKey: string
    license: any | null
    jsonLicense: any | null
  } {
    return {
      model: {},
      deviceID: '',
      licenseKey: '',
      license: null,
      jsonLicense: null,
    }
  },

  computed: {
    getData(): any {
      return this.data
    },

    getJsonLicense(): any | null {
      return this.jsonLicense
    },

    getLicense(): any | null {
      return this.license
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    async setup(): Promise<void> {
      await this.deviceId()
      await this.loadLicense()
    },

    async deviceId(): Promise<void> {
      try {
        const deviceInfo = await this.$bridge.getFingerprint() as DeviceInfo
        console.log(this.$options.name, 'deviceId', 'deviceInfo', deviceInfo)
        if (deviceInfo) {
          this.deviceID = deviceInfo.data || ''
        }
      } catch (error) {
        console.error(this.$options.name, 'deviceId smth wrong', error)
      }
    },

    async loadLicense(): Promise<void> {
      try {
        const licenseData = await this.$bridge.getLicense() as LicenseData
        if (licenseData) {
          console.log(this.$options.name, 'loadLicense', 'licenseData', licenseData)
          this.license = licenseData?.data?.config?.config?.['e-nms'] || licenseData
          this.prepareHeap()
        }
      } catch (error) {
        console.error(this.$options.name, 'loadLicense smth wrong', error)
      }
    },

    async setLicense(): Promise<void> {
      try {
        if (!this.licenseKey?.length) {
          this.$dialog.notify.error(this.$getTranslate('license key is incorrect'), { timeout: 3000 })
          return
        }

        this.setLoader('setLicense', true)
        const response = await this.$bridge.acceptLicense(this.licenseKey) as LicenseResponse
        console.log(this.$options.name, 'setLicense', 'response', response)

        if (response?.data?.accept) {
          this.setLoader('setLicense', false)
          this.$dialog.notify.success(this.$getTranslate('license update success'), { timeout: 5000 })
          await this.setup()
        } else {
          this.$dialog.notify.error(this.$getTranslate('license update smth wrong'), { timeout: 5000 })
          this.setLoader('setLicense', false)
          await this.setup()
        }
      } catch (error) {
        this.$dialog.notify.error(this.$getTranslate('license update smth wrong'), { timeout: 5000 })
        this.setLoader('setLicense', false)
        await this.setup()
        console.error(this.$options.name, 'setLicense smth wrong', error)
      }
    },

    prepareHeap(): void {
      const cycle = (obj: any, name?: string): any => {
        if (!obj) return {}

        const $obj: Record<string, any> = {}
        Object.keys(obj).forEach(key => {
          const value = obj[key]
          if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
            const o = cycle(value, key)
            if (Object.keys(o).length) {
              $obj[key] = o
            } else {
              console.log(this.$options.name, 'prepareHeap', 'empty', key, value)
            }
          } else if (value) {
            $obj[key] = value
          }
        })
        return $obj
      }

      const heap = cycle(this.getLicense)
      console.log(this.$options.name, 'prepareHeap', 'heap', heap)
      this.jsonLicense = heap
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },
  },
})

</script>

<style lang="stylus" scoped>

.text_select

      user-select: text
      -moz-user-select: text
      -webkit-user-select: text

</style>
